import moment from 'moment';

// The fields that make up a transaction's coding, reset to their uncoded values.
// Used everywhere a coding is taken off a row -- clearing the account in
// TransactionListPage, unwinding a match the API refused -- so the list is only
// written down once and the two cannot drift apart. Coding is [] rather than
// undefined because the grid reads row.Coding.length directly.
// accountCodeId and accountType are deliberately not here. Clearing an account has
// never reset them, and prepareCodingDetails sends accountCodeId on to the API, so
// adding them would quietly change what an uncode posts. unwindMatch clears them
// itself, where they were only set by the match selection being undone.
export const CLEARED_CODING = {
  AccountCode: undefined,
  GST: undefined,
  GstCode: undefined,
  gstCodeId: undefined,
  gstAmount: undefined,
  classificationId: undefined,
  contactId: undefined,
  Quantity: undefined,
  Coding: [],
  MatchId: null,
};

export const shapeData = (item, transactionLength, index, lockoffDate) => {
    const isLockOff = (lockoffDate) ? !moment(lockoffDate).isSame('1900-01-01T00:00:00') : false;
    const lockDate = moment(lockoffDate);
    const rowDetails = { ...item, TransactionDate: moment.utc(item.TransactionDate).format('DD MMM YY'), display: true };
   // if ( transactionLength > 15 && transactionLength - index < 10) rowDetails.reverse = true;
    if (item.Coding.length === 1) {
      rowDetails.AccountCode = item.Coding[0].AccountCode;
      rowDetails.Quantity = item.Coding[0].Quantity;
      rowDetails.GstCode = item.Coding[0].GstCode;
      
      const { CodingType } = item.Coding[0];
      rowDetails.lockedDetails = 'Already coded';
      if (CodingType === 'QuickCoding' || CodingType === 'Rule' || CodingType === 'RuleAccepted') rowDetails.lockedDetails = 'QC';

      // if (item.contactId === "00000000-0000-0000-0000-000000000000") {
      //   rowDetails.locked = true;
      //   rowDetails.lockedDetails = 'Transfer already coded';
      // }
    } else if (item.Coding.length > 1) {
      rowDetails.AccountCode = 'split';

      const { CodingType } = item.Coding[0];
      rowDetails.lockedDetails = 'Already coded';
      if (CodingType === 'QuickCoding' || CodingType === 'Rule' || CodingType === 'RuleAccepted') rowDetails.lockedDetails = 'QC';
    }

    if (item.ReconciliationStatus === 2) rowDetails.Reconciled = true;
  
    // Check for locked Bank account
    if (isLockOff && moment(item.TransactionDate).startOf('day').isSameOrBefore(lockDate)) {
      rowDetails.locked = true;
      rowDetails.lockedDetails = 'Bank Account Locked';
    } 
  
    return rowDetails;
  };


// WEBPACK FOOTER //
// ./src/Actions/common.js